module.exports = __webpack_public_path__ + "img/rfa.e9c1ea38.svg";